import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MyAccountService } from '../../services/myAccount.service';
import { BrandingConfigViewModel } from '../../models/branding-config-view-modl';
import { ApiResponse } from '../../models/api-response.model';
import { CommonService } from '../../services';
import { Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
  selector: 'app-portal-branding',
  templateUrl: './portal-branding.component.html',
  styleUrls: ['./portal-branding.component.css']
})
export class PortalBrandingComponent implements OnInit {

  title = 'Branding';
  imageSrc: any;
  color:string = '';//this is the default color.
  getBrandingConfigViewSub$:Subscription;
  saveBrandingConfigSub$:Subscription;
  defaultUrl:string = "";
  formData = new FormData();
  fileList: FileList;
  imageFile: any;
  response:ApiResponse;
  errorMsg: string;
  loadContent: boolean = false;

  constructor(
    private myAccountService : MyAccountService,
    private commonService:CommonService,
    private router: Router,
    private ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    this.ngProgress.start();
    this.getBrandingConfigViewSub$ = this.myAccountService.getBrandingConfigView().subscribe(
      (res:BrandingConfigViewModel)=>{
        //console.log(res);
        this.defaultUrl = res.url;
        this.color = res.accentColour;
        this.imageSrc = `/Cloud/RenderCompanyLogo?accountID=${res.accountID}`
      },
      (error: any) => {
        console.info(error);
      },
      ()=>{

      }
    );
    this.ngProgress.done();
  }

  ngOndestroy() {
    if(this.getBrandingConfigViewSub$){
      this.getBrandingConfigViewSub$.unsubscribe();
    }
  }

  readURL(event):void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  onSelectFile(event) : void {
    this.fileList = event.target.files;

    // Single Image uploading
    if(this.fileList.length > 0){
        console.log("user uplaod a image");
        this.imageFile = event.target.files[0];
        this.formData.append(this.imageFile.name, this.imageFile);
        //console.log(this.formData);
    }
}

  saveBrandingConfig(){

    if(this.defaultUrl && this.color){
      this.saveBrandingConfigSub$ = this.myAccountService.SaveBrandingConfig(this.defaultUrl, this.color, this.formData).subscribe(
        (data: ApiResponse)=>{
          this.response = data;
          this.errorMsg = data.responseMessage;
          this.commonService.showResult("#saveBtn", this.errorMsg, "right", 3000);

        },
        (error: any) => {
          console.info(error);
          this.errorMsg = error.responseMessage;
          this.commonService.showResult("#saveBtn", this.errorMsg, "right", 3000);
        }
      );
    }else{
      if(!this.defaultUrl){
        this.commonService.showResult("#domain", "Please enter URL", "right", 3000);
      }
      
      if(!this.color){
        this.commonService.showResult("#color-picker", "Please choose accent colour", "right", 3000);
      }
    }
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/myAccount');
  }

}